import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// Form Mask
import { Input } from "reactstrap";
import InputMask from "react-input-mask";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import {
  getCompany,
  createCompany,
  editCompany,
  resetCompany,
  resetCompanies,
  resetError,
} from "../../store/actions";

const NewCompany = ({ t }) => {
  let { idCompany } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    dataCompanyGetSet,
    dataCompanyEditCreate,
    loadingCompanyEditCreate,
    successCompany,
    errorCompany,
  } = useSelector((state) => state.Company);

  const [companyValues, setCompanyValues] = useState({
    name: "",
    email: "",
    document: "",
    documentBk: "",
    pj: "",
    domain: "",

    client_info: {
      cep: "",
      address: "",
      neighborhood: "",
      city: "",
      state: "",
      activities: "",
      clientnumber: "",
      responsible: "",
      responsiblenumber: "",
      observation: "",
    },
  });

  const [newFields, setNewFields] = useState({});
  const [clientInfos, setClientInfos] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [labelCpfCnpj, setLabelCpfCnpj] = useState("CNPJ");

  const handleCreateEditCompany = () => {
    if (idCompany) {
      dispatch(
        editCompany(idCompany, {
          ...newFields,
          client_info: Object.assign(companyValues.client_info, clientInfos),
        })
      );
    } else {
      dispatch(createCompany({ ...newFields, client_info: clientInfos }));
    }
  };

  const customInputField = (e) => {
    if (e === "PF") {
      setLabelCpfCnpj("CPF");
    }
    if (e === "PJ") {
      setLabelCpfCnpj("CNPJ");
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successCompany &&
      dispatch(resetCompany()) &&
      dispatch(resetCompanies()) &&
      history.push("/companies"),
  };

  const checkSubmit = () => {
    if (
      Object.keys(newFields).length !== 0 ||
      Object.keys(clientInfos).length !== 0
    ) {
      setEnableSubmit(true);
    } else {
      setEnableSubmit(false);
    }
  };

  useEffect(() => {
    checkSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFields, clientInfos]);

  useEffect(() => {
    dispatch(resetCompany());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idCompany) {
      dispatch(getCompany(idCompany, true));
    } else {
      //TODO: descomentar esta linha caso os dropdowns venham em um formulario do backend
      //dispatch(getAgent(null, true));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idCompany]);

  useEffect(() => {
    if (idCompany && dataCompanyGetSet && dataCompanyGetSet.data) {
      setCompanyValues((previous) => ({
        ...previous,
        name: dataCompanyGetSet.data.name,
        email: dataCompanyGetSet.data.email,
        document: dataCompanyGetSet.data.document,
        documentBk: dataCompanyGetSet.data.document,
        pj: dataCompanyGetSet.data.pj ? "PJ" : "PF",
        domain: dataCompanyGetSet.data.domain,
        client_info: {
          cep: dataCompanyGetSet.data.client_info.cep,
          address: dataCompanyGetSet.data.client_info.address,
          neighborhood: dataCompanyGetSet.data.client_info.neighborhood,
          city: dataCompanyGetSet.data.client_info.city,
          state: dataCompanyGetSet.data.client_info.state,
          activities: dataCompanyGetSet.data.client_info.activities,
          clientnumber: dataCompanyGetSet.data.client_info.clientnumber,
          responsible: dataCompanyGetSet.data.client_info.responsible,
          responsiblenumber:
            dataCompanyGetSet.data.client_info.responsiblenumber,
          observation: dataCompanyGetSet.data.client_info.observation,
        },
      }));
      customInputField(dataCompanyGetSet.data.pj ? "PJ" : "PF");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCompanyGetSet]);

  useEffect(() => {
    if (dataCompanyEditCreate && dataCompanyEditCreate.message) {
      showToast("success", t(dataCompanyEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successCompany]);

  useEffect(() => {
    if (errorCompany && typeof errorCompany === "object") {
      errorCompany.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorCompany) {
        showToast("error", t(errorCompany));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorCompany]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/companies"
            path={idCompany ? "/company/" + idCompany : "/company"}
            title={t("Companies")}
            breadcrumbItem={
              !idCompany ? t("Create company") : t("Edit Company")
            }
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleCreateEditCompany}>
                    <Row>
                      <Col sm="6">
                        <FormGroup>
                          <AvField
                            value={companyValues.pj}
                            onMouseUp={customInputField}
                            name="pfpj"
                            id="pfpj"
                            className="form-control"
                            type="select"
                            label=" PF/PJ *"
                            onChange={(e) => {
                              customInputField(e.target.value);
                              setCompanyValues({
                                ...companyValues,
                                document: "",
                                pj: e.target.value,
                              });
                              setNewFields({
                                ...newFields,
                                pj: e.target.value === "PJ" ? true : false,
                              });
                            }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          >
                            <option value="" disabled>
                              {t("Select")}
                            </option>
                            <option value="PF">PF</option>
                            <option value="PJ">PJ</option>
                          </AvField>
                        </FormGroup>

                        <FormGroup>
                          <AvField
                            value={companyValues.name}
                            label={t("Name") + " *"}
                            id="companyname"
                            name="companyname"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter your company name")}
                            onChange={(e) => {
                              if (e.target.value === companyValues.name) {
                                delete newFields.name;
                                checkSubmit();
                              } else {
                                setNewFields({
                                  ...newFields,
                                  name: e.target.value,
                                });
                              }
                            }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 50,
                                errorMessage: t("Invalid field"),
                              },
                              pattern: {
                                value:
                                  "/^[A-Za-z0-9 àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Your name must be composed only with letter and numbers"
                                ),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={companyValues.domain}
                            label={t("Site") + " *"}
                            id="site"
                            name="domain"
                            type="text"
                            className="form-control"
                            placeholder={t("www.mycompany.com")}
                            onChange={(e) => {
                              if (e.target.value === companyValues.domain) {
                                delete newFields.domain;
                                checkSubmit();
                              } else {
                                setNewFields({
                                  ...newFields,
                                  domain: e.target.value,
                                });
                              }
                            }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 50,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={companyValues.client_info.address}
                            label={t("Address")}
                            id="address"
                            name="address"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter street name and number")}
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                companyValues.client_info.address
                              ) {
                                delete clientInfos.address;
                                checkSubmit();
                              } else {
                                setClientInfos({
                                  ...clientInfos,
                                  address: e.target.value,
                                });
                              }
                            }}
                          />
                        </FormGroup>

                        <FormGroup>
                          <AvField
                            value={companyValues.client_info.city}
                            label={t("City")}
                            id="city"
                            name="city"
                            type="text"
                            className="form-control"
                            placeholder={t("City")}
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                companyValues.client_info.city
                              ) {
                                delete clientInfos.city;
                                checkSubmit();
                              } else {
                                setClientInfos({
                                  ...clientInfos,
                                  city: e.target.value,
                                });
                              }
                            }}
                            validate={{
                              maxLength: {
                                value: 50,
                                errorMessage: t("Invalid field"),
                              },
                              pattern: {
                                value:
                                  "/^[A-Za-z0-9 àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Your City must be composed only with letter, numbers and space"
                                ),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={companyValues.client_info.responsible}
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                companyValues.client_info.responsible
                              ) {
                                delete clientInfos.responsible;
                                checkSubmit();
                              } else {
                                setClientInfos({
                                  ...clientInfos,
                                  responsible: e.target.value,
                                });
                              }
                            }}
                            label={t("Responsible")}
                            id="responsible"
                            name="responsible"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter the name of the Responsible")}
                            validate={{
                              maxLength: {
                                value: 50,
                                errorMessage: t("Invalid field"),
                              },
                              pattern: {
                                value:
                                  "/^[A-Za-z àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/i", // only letters and space
                                errorMessage: t(
                                  "Responsible name must be composed only with letter and space"
                                ),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={companyValues.client_info.clientnumber}
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                companyValues.client_info.clientnumber
                              ) {
                                delete clientInfos.clientnumber;
                                checkSubmit();
                              } else {
                                setClientInfos({
                                  ...clientInfos,
                                  clientnumber: e.target.value,
                                });
                              }
                            }}
                            label={t("Company number")}
                            id="clientnumber"
                            name="clientnumber"
                            type="text"
                            className="form-control"
                            placeholder="(__)_____-____"
                            tag={[Input, InputMask]}
                            mask="(99)99999-9999"
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={companyValues.client_info.observation}
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                companyValues.client_info.observation
                              ) {
                                delete clientInfos.observation;
                                checkSubmit();
                              } else {
                                setClientInfos({
                                  ...clientInfos,
                                  observation: e.target.value,
                                });
                              }
                            }}
                            label={t("Observation")}
                            id="observation"
                            name="observation"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter your observations")}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup>
                          <AvField
                            label={`${labelCpfCnpj} *`}
                            value={companyValues.document}
                            tag={[Input, InputMask]}
                            mask={
                              labelCpfCnpj === "CPF"
                                ? "999.999.999-99"
                                : "99.999.999/9999-99"
                            }
                            id="CPFCNPJ"
                            name="CPFCNPJ"
                            type="text"
                            className="form-control"
                            placeholder={
                              labelCpfCnpj === "CPF"
                                ? "___.___.___.__"
                                : "__.___.___/____.__"
                            }
                            onChange={(e) => {
                              if (e.target.value === companyValues.documentBk) {
                                delete newFields.document;
                                delete newFields.pj;
                                checkSubmit();
                              } else {
                                setNewFields({
                                  ...newFields,
                                  document: e.target.value,
                                  pj: companyValues.pj === "PJ" ? true : false,
                                });
                                setCompanyValues({
                                  ...companyValues,
                                  document: e.target.value,
                                });
                              }
                            }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              pattern: {
                                value: "/^[0-9./-]+$/", // only numbers, dots, slash and dashes
                                errorMessage: t(
                                  `Your CPF/CNPJ must be composed only with numbers, dots and slashs`
                                ),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={companyValues.email}
                            label={t("Email") + " *"}
                            id="email"
                            name="email"
                            type="email"
                            className="form-control"
                            placeholder={t("example@example.com")}
                            onChange={(e) => {
                              if (e.target.value === companyValues.email) {
                                delete newFields.email;
                                checkSubmit();
                              } else {
                                setNewFields({
                                  ...newFields,
                                  email: e.target.value,
                                });
                              }
                            }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              email: {
                                value: true,
                                errorMessage: t("Incorrect email"),
                              },
                              maxLength: {
                                value: 50,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={companyValues.client_info.cep}
                            label={t("Postal code")}
                            tag={[Input, InputMask]}
                            mask="99999-999"
                            id="cep"
                            name="cep"
                            type="text"
                            className="form-control"
                            placeholder="_____-___"
                            onChange={(e) => {
                              if (
                                e.target.value === companyValues.client_info.cep
                              ) {
                                delete clientInfos.cep;
                                checkSubmit();
                              } else {
                                setClientInfos({
                                  ...clientInfos,
                                  cep: e.target.value,
                                });
                              }
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={companyValues.client_info.neighborhood}
                            label={t("Neighborhood")}
                            id="neighborhood"
                            name="neighborhood"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter the neighborhood")}
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                companyValues.client_info.neighborhood
                              ) {
                                delete clientInfos.neighborhood;
                                checkSubmit();
                              } else {
                                setClientInfos({
                                  ...clientInfos,
                                  neighborhood: e.target.value,
                                });
                              }
                            }}
                            validate={{
                              maxLength: {
                                value: 50,
                                errorMessage: t("Invalid field"),
                              },
                              pattern: {
                                value:
                                  "/^[A-Za-z0-9 àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Your Neighborhood must be composed only with letter, numbers and space"
                                ),
                              },
                            }}
                          />
                        </FormGroup>

                        <FormGroup>
                          <AvField
                            value={companyValues.client_info.state}
                            name="state"
                            className="form-control"
                            type="select"
                            label={t("State")}
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                companyValues.client_info.state
                              ) {
                                delete clientInfos.state;
                                checkSubmit();
                              } else {
                                setClientInfos({
                                  ...clientInfos,
                                  state: e.target.value,
                                });
                              }
                            }}
                          >
                            <option value="" disabled>
                              {t("Select")}
                            </option>
                            <option value="AC">Acre</option>
                            <option value="AL">Alagoas</option>
                            <option value="AP">Amapá</option>
                            <option value="AM">Amazonas</option>
                            <option value="BA">Bahia</option>
                            <option value="CE">Ceará</option>
                            <option value="DF">Distrito Federal</option>
                            <option value="ES">Espirito Santo</option>
                            <option value="GO">Goiás</option>
                            <option value="MA">Maranhão</option>
                            <option value="MS">Mato Grosso do Sul</option>
                            <option value="MT">Mato Grosso</option>
                            <option value="MG">Minas Gerais</option>
                            <option value="PA">Pará</option>
                            <option value="PB">Paraíba</option>
                            <option value="PR">Paraná</option>
                            <option value="PE">Pernambuco</option>
                            <option value="PI">Piauí</option>
                            <option value="RJ">Rio de Janeiro</option>
                            <option value="RN">Rio Grande do Norte</option>
                            <option value="RS">Rio Grande do Sul</option>
                            <option value="RO">Rondônia</option>
                            <option value="RR">Roraima</option>
                            <option value="SC">Santa Catarina</option>
                            <option value="SP">São Paulo</option>
                            <option value="SE">Sergipe</option>
                            <option value="TO">Tocantins</option>
                          </AvField>
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={companyValues.client_info.activities}
                            className="form-control"
                            name="activities"
                            type="select"
                            label={t("Activity")}
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                companyValues.client_info.activities
                              ) {
                                delete clientInfos.activities;
                                checkSubmit();
                              } else {
                                setClientInfos({
                                  ...clientInfos,
                                  activities: e.target.value,
                                });
                              }
                            }}
                          >
                            <option value="" disabled>
                              {t("Select")}
                            </option>
                            <option value="Academia-de-Esportes">
                              Academia de Esportes
                            </option>
                            <option value="Artes-Marciais">
                              Artes Marciais
                            </option>
                            <option value="Açúcar-Álcool">
                              Açúcar e Álcool
                            </option>
                            <option value="Administração-Participação">
                              Administração e Participação
                            </option>
                            <option value="Agências-de-Turismo-Viagem">
                              Agências de Turismo / Viagem
                            </option>
                            <option value="Agricultura-Pecuária-Silvicultura">
                              Agricultura / Pecuária / Silvicultura
                            </option>
                            <option value="Alimentos">Alimentos</option>
                            <option value="Arquitetura-Paisagismo-Urbanismo">
                              Arquitetura / Paisagismo / Urbanismo
                            </option>
                            <option value="Assessoria-de-Imprensa">
                              DAssessoria de Imprensa
                            </option>
                            <option value="Automação">Automação</option>
                            <option value="Automotivo">Automotivo</option>
                            <option value="Bancário-Financeiro">
                              Bancário / Financeiro
                            </option>
                            <option value="Bebidas">Bebidas</option>
                            <option value="Bens de Capital">
                              Bens de Capital
                            </option>
                            <option value="Bens de Consumo (Outros)">
                              Bens de Consumo (Outros)
                            </option>
                            <option value="Borracha">Borracha</option>
                            <option value="Café">Café</option>
                            <option value="Calçados">Calçados</option>
                            <option value="Comércio-Atacadista">
                              Comércio Atacadista
                            </option>
                            <option value="Comércio-Varejista">
                              Comércio Varejista
                            </option>
                            <option value="Comunicação">Comunicação</option>
                            <option value="Concessionárias-Auto Peças">
                              Concessionárias / Auto Peças
                            </option>
                            <option value="Construção-Civil">
                              Construção Civil
                            </option>
                            <option value="Consultoria-Geral">
                              Consultoria Geral
                            </option>
                            <option value="Contabilidade-Auditoria">
                              Contabilidade / Auditoria
                            </option>
                            <option value="Corretagem-Imóveis-">
                              Corretagem (Imóveis)
                            </option>
                            <option value="Corretagem-Seguros">
                              Corretagem (Seguros)
                            </option>
                            <option value="Corretagem-de-Títulos-e-Valores-Imobiliários">
                              Corretagem de Títulos e Valores Imobiliários
                            </option>
                            <option value="Cosméticos">Cosméticos</option>
                            <option value="Diversão-Entretenimento">
                              Diversão / Entretenimento
                            </option>
                            <option value="Educação-Idiomas">
                              Educação / Idiomas
                            </option>
                            <option value="Eletrônica-Eletroeletrônica-Eletrodomésticos">
                              Eletrônica / Eletroeletrônica / Eletrodomésticos
                            </option>
                            <option value="Energia-Eletricidade">
                              Energia / Eletricidade
                            </option>
                            <option value="Engenharia">Engenharia</option>
                            <option value="Equipamentos-industriais">
                              Equipamentos-industriais
                            </option>
                            <option value="Equipamentos-médicos-precisão">
                              Equipamentos médicos / precisão
                            </option>
                            <option value="Estética-Academias">
                              Estética / Academias
                            </option>
                            <option value="Eventos">Eventos</option>
                            <option value="Farmacêutica-Veterinária">
                              Farmacêutica/ Veterinária
                            </option>
                            <option value="Financeiras">Financeiras</option>
                            <option value="Gráfica-Editoras">
                              Gráfica / Editoras
                            </option>
                            <option value="Importação-Exportação">
                              Importação / Exportação
                            </option>
                            <option value="Incorporadora">Incorporadora</option>
                            <option value="Indústrias">Indústrias</option>
                            <option value="Informática">Informática</option>
                            <option value="Internet-Sites">
                              Internet / Sites
                            </option>
                            <option value="Jornais">Jornais</option>
                            <option value="Jurídica">Jurídica</option>
                            <option value="Logística-Armazéns">
                              Logística / Armazéns
                            </option>
                            <option value="Madeiras">Madeiras</option>
                            <option value="Materiais-de-Construção">
                              Materiais de Construção
                            </option>
                            <option value="Material-de-Escritório">
                              Material de Escritório
                            </option>
                            <option value="Mecânica-Manutenção">
                              Mecânica / Manutenção
                            </option>
                            <option value="Metalúrgica-Siderúrgica">
                              Metalúrgica / Siderúrgica
                            </option>
                            <option value="Mineração">Mineração</option>
                            <option value="Móveis-e-Artefatos-de-decoração">
                              Móveis e Artefatos de decoração
                            </option>
                            <option value="Órgãos-públicos">
                              Órgãos públicos
                            </option>
                            <option value="Outros">Outros</option>
                            <option value="Papel-e-Derivados">
                              Papel-e-Derivados
                            </option>
                            <option value="Petroquímico-Petróleo">
                              Petroquímico / Petróleo
                            </option>
                            <option value="Plásticos">Plásticos</option>
                            <option value="Prestadora-de-Serviços">
                              Prestadora de Serviços
                            </option>
                            <option value="Publicidade-Propaganda">
                              Publicidade / Propaganda
                            </option>
                            <option value="Recursos-Humanos">
                              Recursos Humanos
                            </option>
                            <option value="Relações-Públicas">
                              Relações Públicas
                            </option>
                            <option value="Representação-Comercial">
                              Representação Comercial
                            </option>
                            <option value="Restaurante-Industrial-Fast FoodJ">
                              Restaurante / Industrial / Fast Food
                            </option>
                            <option value="Saúde">Saúde</option>
                            <option value="Segurança-Patrimonial">
                              Segurança Patrimonial
                            </option>
                            <option value="Seguros-PrevidênciaPrivada">
                              Seguros / Previdência Privada
                            </option>
                            <option value="Sindicatos-Associações-ONGs">
                              Sindicatos / Associações / ONGs
                            </option>
                            <option value="Supermercado-Hipermercado">
                              Supermercado / Hipermercado
                            </option>
                            <option value="Telecomunicações">
                              Telecomunicações
                            </option>
                            <option value="Telemarketing-Call-Center">
                              Telemarketing / Call Center
                            </option>
                            <option value="Têxtil-Couro">Têxtil / Couro</option>
                            <option value="Transportes">Transportes</option>
                            <option value="Turismo-Hotelaria">
                              Turismo / Hotelaria
                            </option>
                          </AvField>
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={companyValues.client_info.responsiblenumber}
                            label={t("Responsible number")}
                            id="responsiblenumber"
                            name="responsiblenumber"
                            type="text"
                            className="form-control"
                            placeholder="(__)_____-____"
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                companyValues.client_info.responsiblenumber
                              ) {
                                delete clientInfos.responsiblenumber;
                                checkSubmit();
                              } else {
                                setClientInfos({
                                  ...clientInfos,
                                  responsiblenumber: e.target.value,
                                });
                              }
                            }}
                            tag={[Input, InputMask]}
                            mask="(99)99999-9999"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingCompanyEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/companies">
                      {" "}
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect"
                        onClick={() => dispatch(resetCompany())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewCompany);
